export default __webpack_public_path__ + "static/media/TV_Senado.88b59659.png";